import { takeLatest, call, put, select } from 'redux-saga/effects'

import { indicateProgress } from 'api'
import { userSelector } from 'auth/selectors'
import * as nuveiApi from 'credit-cards/nuvei/api'
import * as creditCardApi from 'credit-cards/grsApi'
import * as creditCardActions from 'credit-cards/actions'
import { verifyGuestCreditCardSuccess } from 'booking/actions'
import { ADD_GUEST_PAYMENT_METHOD, ADD_PAYMENT_METHOD, INIT_PAYMENT } from 'credit-cards/constants'

function* addNewCard({ data, successCallback }) {
    try {
        yield call(indicateProgress, 'creditCard', function* () {
            const user = yield select(userSelector)

            const lAZAccountCardDetail = yield call(nuveiApi.fetchNuveiCCToken, {
                ...data,
                Token: user.token,
            })

            yield call(creditCardApi.saveCardData, user.token, lAZAccountCardDetail)
            yield put(creditCardActions.addPaymentMethodSuccess())
            successCallback && successCallback()
        })
    } catch (error) {
        // Error is caught with indicateProgress saga
    }
}

function* addNewGuestCard({ data, successCallback }) {
    try {
        yield call(indicateProgress, 'creditCard', function* () {
            const cardData = {
                nickName: data.CustomerName,
                token: data.CardNumber,
                nuveiSessionToken: data.SessionToken,
            }
            yield put(verifyGuestCreditCardSuccess(cardData))
            yield put(creditCardActions.addPaymentMethodSuccess())
            successCallback && successCallback()
        })
    } catch (error) {
        // Error is caught with indicateProgress saga
    }
}

function* nuveiPaymentSaga() {
    yield put(creditCardActions.paymentSuccess())
}

export function* rootSaga() {
    yield takeLatest(ADD_PAYMENT_METHOD, addNewCard)
    yield takeLatest(ADD_GUEST_PAYMENT_METHOD, addNewGuestCard)
    yield takeLatest(INIT_PAYMENT, nuveiPaymentSaga)
}
